const Footer = () => {
  return (
    <footer className="footer">
      <article className="copy">
        {/* <p>License #0786828</p> */}
        <a href="https://drive.google.com/file/d/1We0UKbuoicIsn0L5NzZNfKxtnJ2krum6/view?usp=drive_link" target="_blank" rel="noreferrer">Information About Broker Services</a>
        <br />
        <a href="https://drive.google.com/file/d/1C23fRAAW2YJ97IN-iZTy-jEnGME3FIc5/view?usp=drive_link" target="_blank" rel="noreferrer">Consumer Protection Notice</a>
        <p className="legal">© {new Date().getFullYear()} Bebeau Realty Group</p>
        <p className="dev">Website development by <a href="https://cltdev.com" target="_blank" rel="noreferrer">CLTDEV.com</a></p>
      </article>
    </footer>
  );
}

export default Footer;
